let resumeData = {
    "imagebaseurl":"",
    "name": "ur mom",
    "role": "student of CS1300",
    "linkedinId":"https://www.linkedin.com/ur_mom",
    "email": "ur_mom@brown.edu",
    "skypeid": "Your skypeid",
    "roleDescription": " I like ur mom.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/",
          "className":"fa fa-github"
        },
        {
          "name":"skype",
          "url":"https://twitter.com/?lang=en",
          "className":"fa fa-twitter"
        }
      ],
    "aboutme":"I am not currently a junior at Brown University concentrating in ur mom.",
    "address":"Providence, RI",
    "website":"ur_mom@brown.edu",
    // "education":[
    //   {
    //     "UniversityName":"Brown University",
    //     "specialization":"Some specialization",
    //     "MonthOfPassing":"Aug",
    //     "YearOfPassing":"2020",
    //     "Achievements":"Some Achievements"
    //   },
    //   {
    //     "UniversityName":"Some University",
    //     "specialization":"Some specialization",
    //     "MonthOfPassing":"Jan",
    //     "YearOfPassing":"2018",
    //     "Achievements":"Some Achievements"
    //   }
    // ],
    // "work":[
    //   {
    //     "CompanyName":"Some Company",
    //     "specialization":"Some specialization",
    //     "MonthOfLeaving":"Jan",
    //     "YearOfLeaving":"2018",
    //     "Achievements":"Some Achievements"
    //   },
    //   {
    //     "CompanyName":"Some Company",
    //     "specialization":"Some specialization",
    //     "MonthOfLeaving":"Jan",
    //     "YearOfLeaving":"2018",
    //     "Achievements":"Some Achievements"
    //   }
    // ],
    // "skillsDescription":"Your skills here",
    // "skills":[
    //   {
    //     "skillname":"HTML5"
    //   },
    //   {
    //     "skillname":"CSS"
    //   },
    //   {
    //     "skillname":"Reactjs"
    //   }
    // ],
    "portfolio":[
      {
        "name":"Iterative Redesign",
        "description":"Click the button to check out the process!",
        "imgurl":"images/mooji.png",
        "url": "https://maladjustedcarp401.github.io/Iterative_Design/"
      },
      {
        "name":"Development",
        "description":"Click the button to check out my bakery!",
        "imgurl":"images/bakery.png",
        "url": "https://happysnail246.github.io/Development/"
      },
      {
        "name":"Storyboarding",
        "description":"Click the button to check out the process!",  
        "imgurl":"images/microwave.png",
        "url": "https://happysnail246.github.io/Personas_Storyboarding/"
      },
      {
        "name":"Responsive Redesign",
        "description":"Click the button to check out the process!",
        "imgurl":"images/zara.png",
        "url": " https://happysnail246.github.io/Responsive-Redesign-Handin/"
      }
    ],
    "testimonials":[
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      },
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      }
    ]
  }
  
  export default resumeData